import baseMoment from 'moment-timezone';
import i18n from 'i18next';

baseMoment.locale(i18n.language);

export { baseMoment };

const moment = (date) => baseMoment.parseZone(date).tz('America/Bogota', true);
export default moment;

export const getCompatibleDateFormat = (date, includeTime = false) => {
  if (!date) return null;
  const splittedDate = date.split('/');
  const joinedDate = [splittedDate[1], splittedDate[0], splittedDate[2]].join('/');
  return includeTime ? joinedDate.split(' - ').join(' ') : joinedDate;
};

// TODO use baseMoment instead moment when date fields support timezone param
// this format is only used in requests
export const getEventtiaDateFormat = (date, includeTime = false) => (
  moment(date).format(`DD/MM/YYYY${includeTime ? ' - HH:mm' : ''}`)
);

export const getEventTimeFormat = (events, options = {}) => {
  const { includeSeconds = false, includeMinutes = true } = options;
  const timeFormat = Object.values(events)[0]?.timeFormat;
  const seconds = includeSeconds ? ':ss' : '';
  const minutes = (includeSeconds || includeMinutes) ? ':mm' : '';
  return timeFormat === 'hours_24' ? `HH${minutes}${seconds}` : `h${minutes}${seconds} A`;
};

// Locales where moment's `Do` adds unwanted ordinal suffixes (º, etc.)
const PLAIN_DAY_LOCALES = ['es', 'it', 'pt'];

const isPlainDayLocale = (locale) => PLAIN_DAY_LOCALES.includes(locale);

/**
 * @param {'short'|'full'|'fullYear'|'fullDayYear'} template
 * @param {string} locale
 */
export const getLocaleDateFormat = (template, locale) => {
  const plain = isPlainDayLocale(locale);
  switch (template) {
    case 'short':
      if (locale === 'fr') return 'Do MMM';
      if (locale === 'pt') return 'D MMMM';
      return plain ? 'MMM D' : 'MMM Do';
    case 'full':
      if (locale === 'fr') return 'Do MMM';
      return plain ? 'dddd, MMMM D' : 'dddd, MMMM Do';
    case 'fullYear':
      return plain ? 'MMMM D YYYY' : 'MMMM Do YYYY';
    case 'fullDayYear':
      return plain ? 'dddd, MMMM D YYYY' : 'dddd, MMMM Do YYYY';
    case 'dayPicker':
      if (locale === 'pt') return 'dddd, D [de] MMMM';
      if (locale === 'it') return 'dddd, D MMMM';
      if (locale === 'ja' || locale === 'zh') return 'MMMM Do dddd';
      if (locale === 'en') return 'dddd, MMMM Do';
      return 'dddd, MMMM D';
    default:
      return plain ? 'MMM D' : 'MMM Do';
  }
};

export const formatDay = (date, locale) => (
  baseMoment(date).locale(locale).format(getLocaleDateFormat('dayPicker', locale))
);

export const showInEventTimezone = (appSettings) => {
  const { timeVisualization = 'user_timezone' } = appSettings;
  return timeVisualization === 'event_timezone';
};
